'use client';

import { useTranslation } from 'next-i18next';

import { useEffect, useState } from 'react';

import { Box, Text } from '@chakra-ui/react';

import { MapSpinner } from '@app/components/atoms/map-spinner';
import { Map } from '@app/components/templates/map-root';
import { runWhenIdle } from '@app/helpers/ssr.helpers';
import { useMapSearch } from '@app/hooks/useMapSearch';

export const MapWrapper = () => {
    const { t } = useTranslation('common', {
        keyPrefix: 'map',
    });

    const { isMapLoaded, isLoadingAccommodations, isClustering } = useMapSearch();
    const [isMapVisible, setIsMapVisible] = useState(false);

    useEffect(() => {
        if (!isMapLoaded) return;

        // Display the map only after it finishes loading
        runWhenIdle(() => setIsMapVisible(true));
    }, [isMapLoaded]);

    return (
        <>
            {/* LCP element placeholder */}
            {!isMapVisible ? (
                <Text
                    fontSize="2xl"
                    alignSelf="center"
                    whiteSpace="nowrap"
                    padding={8}
                    color="white"
                >
                    {t('loadingLabel')}
                </Text>
            ) : null}

            {/* Wrapper for smooth map reveal after load (LCP optimization) */}
            <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                opacity={isMapVisible ? 1 : 0}
                visibility={isMapVisible ? 'visible' : 'hidden'}
                pointerEvents={isMapVisible ? 'auto' : 'none'}
                transition="opacity 0.6s ease, visibility 0.6s ease"
                data-testid="map-wrapper"
            >
                <Map.MapView />
            </Box>

            {(isLoadingAccommodations || isClustering || !isMapLoaded) && <MapSpinner />}
        </>
    );
};
